import { Flex, Menu, Text } from '@mantine/core';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import TreeNodeOptions from '@/components/shared/TreeNodeOptions';
import { ROUTES } from '@/configs/routes';
import { FollowUpEntity } from '@/entities/FollowUp';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';
import { useDevices } from '@/utils/devices';
import { getNoteStatus } from '@/utils/getNoteStatus';

import FollowUpBadge from './FollowUpBadge';

import s from './Action.module.scss';

type Props = {
  model: FollowUpEntity;
};

const Actions: React.FC<Props> = ({ model }) => {
  const { isCompactViewport } = useDevices();

  const navigate = useNavigate();
  const { id } = useParams();

  const {
    followUp: { removePopup },
  } = useSidebarNoteStore();

  const status = getNoteStatus(model.createdAt === model.updatedAt, model.createdAt, model.updatedAt);

  const handleOpenRemovePopup = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
      event.stopPropagation();
      removePopup.open(model);
    },
    [model, removePopup],
  );

  const handleEdit = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
      event.stopPropagation();

      if (!id) {
        return;
      }

      navigate(ROUTES.organization.notebook.followUps.followUp.edit.create(id, String(model.id)), {
        state: {
          detailUpdatedAt: model.updatedAt,
          detailCreatedAt: model.createdAt,
        },
      });
    },
    [id, model.createdAt, model.id, model.updatedAt, navigate],
  );

  return (
    <>
      <FollowUpBadge model={model} />
      <Flex align="center" gap="sm">
        <Text size="xs" lh="xxs">
          {status}
        </Text>
        <TreeNodeOptions
          dropdownClassName={s.root}
          items={
            <>
              {!isCompactViewport && (
                <Menu.Item className={s.root__item} onClick={handleEdit}>
                  <Text size="sm">Редактировать</Text>
                </Menu.Item>
              )}
              <Menu.Item className={s.root__item} onClick={handleOpenRemovePopup}>
                <Text c="red" size="sm">
                  Удалить
                </Text>
              </Menu.Item>
            </>
          }
        />
      </Flex>
    </>
  );
};

export default React.memo(Actions);
